export default __webpack_public_path__ + "static/media/sudin.2d9f872c.png";